import axios from "axios";
import { Base_URL } from "../url";

// Fetch all tickets
export const getAllTickets = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/TicketBasedOrganization/GetAllTickets`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching tickets:", error);
    throw error;
  }
};

// NEW: Fetch ticket by ticketId
export const getTicketByTicketId = async (ticketId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TicketBasedOrganization/GetByTicketId/${ticketId}`,
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching ticket with ID ${ticketId}:`, error);
    throw error;
  }
};

// NEW: Fetch tickets by Assigned Resource ID
export const getTicketsByAssignedResource = async (resourceId) => {
  try {
    if (!resourceId) {
      throw new Error("resourceId is required");
    }

    const response = await axios.get(
      `${Base_URL}/TicketBasedOrganization/GetByAssignedResource/${resourceId}`,
    );

    return response.data;
  } catch (error) {
    console.error(
      `Error fetching tickets for assigned resource ${resourceId}:`,
      error,
    );
    throw error.response?.data || error;
  }
};

// Fetch tickets by orgId
export const getTicketsByOrgId = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TicketBasedOrganization/GetByOrgId/${orgId}`,
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching tickets for orgId ${orgId}:`, error);
    throw error;
  }
};

// Create new ticket

export const createTicket = async (data) => {
  return axios.post(`${Base_URL}/TicketBasedOrganization/CreateTicket`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
// export const createTicket = async (ticketData) => {
//   try {
//     const response = await axios.post(
//       `${Base_URL}/TicketBasedOrganization/CreateTicket`,
//       ticketData,
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Error creating ticket:", error);
//     throw error;
//   }
// };

// Fetch tickets by projectId
export const getTicketsByProjectId = async (projectId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TicketBasedOrganization/GetByProjectId/${projectId}`,
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching tickets for projectId ${projectId}:`, error);
    throw error;
  }
};

// Update existing ticket
export const updateTicket = async (ticketId, ticketData) => {
  try {
    const response = await axios.put(
      `${Base_URL}/TicketBasedOrganization/UpdateTicket/${ticketId}`,
      ticketData,
    );
    return response.data;
  } catch (error) {
    console.error(`Error updating ticket ${ticketId}:`, error);
    throw error;
  }
};

// Microsoft OAuth APIs
export const microsoftOAuthApi = {
  // Start OAuth flow
  connectOrganization: async (orgId) => {
    const response = await axios.get(
      `${Base_URL}/MicrosoftOAuth/Connect/${orgId}`,
    );
    return response.data;
  },

  // Check connection status
  getConnectionStatus: async (orgId) => {
    const response = await axios.get(
      `${Base_URL}/MicrosoftOAuth/Status/${orgId}`,
    );
    return response.data;
  },

  // Disconnect organization
  disconnectOrganization: async (orgId) => {
    const response = await axios.delete(
      `${Base_URL}/MicrosoftOAuth/Disconnect/${orgId}`,
    );
    return response.data;
  },

  // Test email connection
  testEmailConnection: async (orgId) => {
    const response = await axios.post(
      `${Base_URL}/EmailProcessing/TestConnection/${orgId}`,
    );
    return response.data;
  },
};

// Organization Email APIs
export const organizationEmailApi = {
  // Get all organization emails
  getAllOrganizationEmails: async () => {
    const response = await axios.get(
      `${Base_URL}/OrganizationEmailsForTicket/GetAllOrganizationEmails`,
    );
    return response.data;
  },

  // Get emails by orgId
  getEmailsByOrgId: async (orgId) => {
    const response = await axios.get(
      `${Base_URL}/OrganizationEmailsForTicket/GetByOrgId/${orgId}`,
    );
    return response.data;
  },

  // Create organization email
  createOrganizationEmail: async (emailData) => {
    const response = await axios.post(
      `${Base_URL}/OrganizationEmailsForTicket/CreateOrganizationEmail`,
      emailData,
    );
    return response.data;
  },

  // Create multiple organization emails
  createMultipleOrganizationEmails: async (emailsData) => {
    const response = await axios.post(
      `${Base_URL}/OrganizationEmailsForTicket/CreateMultipleOrganizationEmails`,
      emailsData,
    );
    return response.data;
  },
};

// Email Processing APIs
export const emailProcessingApi = {
  // Process emails for organization
  processOrganizationEmails: async (orgId) => {
    const response = await axios.post(
      `${Base_URL}/EmailProcessing/ProcessOrganizationEmails/${orgId}`,
    );
    return response.data;
  },

  // Process all organizations emails
  processAllOrganizationsEmails: async () => {
    const response = await axios.post(
      `${Base_URL}/EmailProcessing/ProcessAllOrganizationsEmails`,
    );
    return response.data;
  },

  // Test email connection
  testEmailConnection: async (orgId) => {
    const response = await axios.post(
      `${Base_URL}/EmailProcessing/TestConnection/${orgId}`,
    );
    return response.data;
  },
};

// Attachment APIs
export const attachmentApi = {
  // Get ticket attachments
  getTicketAttachments: async (ticketId) => {
    const response = await axios.get(
      `${Base_URL}/TicketBasedOrganization/GetTicketAttachments/${ticketId}`,
    );
    return response.data;
  },

  // Download attachment
  downloadAttachment: async (blobUrl, fileName) => {
    const response = await axios.get(
      `${Base_URL}/TicketBasedOrganization/DownloadAttachment`,
      {
        params: { blobUrl, fileName },
        responseType: "blob", // Important for file downloads
      },
    );
    return response;
  },

  // View attachment in browser
  viewAttachment: async (blobUrl, fileName) => {
    const response = await axios.get(
      `${Base_URL}/TicketBasedOrganization/ViewAttachment`,
      {
        params: { blobUrl, fileName },
        responseType: "blob",
      },
    );
    return response;
  },
};

// =====================================
// 🎯 Ticket Assignment Tracking APIs
// =====================================

// ✅ Start Work
export const startWork = async (ticketId, userId, orgId) => {
  const response = await axios.post(
    `${Base_URL}/TicketAssignmentTracking/StartWork`,
    {
      TicketId: ticketId,
      AssignedUserId: userId,
      OrgId: orgId?.toString(),
    },
  );
  return response.data;
};

// ✅ Stop Work
export const stopWork = async (assignmentId) => {
  const response = await axios.post(
    `${Base_URL}/TicketAssignmentTracking/StopWork/${assignmentId}`,
  );
  return response.data;
};

// ✅ Get all assignments
export const getAllAssignments = async () => {
  const response = await axios.get(
    `${Base_URL}/TicketAssignmentTracking/GetAllAssignments`,
  );
  return response.data;
};

// ✅ Get assignments by ticketId
export const getAssignmentsByTicketId = async (ticketId) => {
  const response = await axios.get(
    `${Base_URL}/TicketAssignmentTracking/GetByTicketId/${ticketId}`,
  );
  return response.data;
};

// ✅ Get active assignments
export const getActiveAssignments = async () => {
  const response = await axios.get(
    `${Base_URL}/TicketAssignmentTracking/GetActiveAssignments`,
  );
  return response.data;
};

// ✅ Update assignment
export const updateAssignment = async (assignmentId, updateData) => {
  const response = await axios.put(
    `${Base_URL}/TicketAssignmentTracking/UpdateAssignment/${assignmentId}`,
    updateData,
  );
  return response.data;
};

// ✅ Get ticket assignments by AssignedUserId & OrgId
export const getTicketAssignmentsByUserAndOrg = async (
  assignedUserId,
  orgId,
) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TicketAssignmentTracking/GetByUserAndOrg/${assignedUserId}/${orgId}`,
    );

    // Backend returns [] when no data → safe for UI
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    // 🚫 Do NOT throw error for no data
    if (error?.response?.status === 404) {
      return [];
    }

    console.error(
      `Error fetching ticket assignments for user ${assignedUserId} in org ${orgId}:`,
      error,
    );

    // Return empty list instead of breaking UI
    return [];
  }
};

export const addTicketLog = async (payload) => {
  return axios.post(`${Base_URL}/TicketLog/AddLog`, payload);
};

// =====================================
// 🎯 Ticket Closure Type APIs
// =====================================

// Fetch all ticket closure types
export const getAllTicketClosureTypes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/TicketClosureType/GetAll`);

    return response.data;
  } catch (error) {
    console.error("Error fetching ticket closure types:", error);
    throw error;
  }
};

// =====================================
// 🎯 Ticket Closure APIs
// =====================================

// Close ticket with multiple efforts
export const closeTicket = async (payload) => {
  try {
    const response = await axios.post(
      `${Base_URL}/TicketLog/CloseTicket`,
      payload,
    );

    return response.data;
  } catch (error) {
    console.error("❌ Error closing ticket:", error);
    throw error;
  }
};

// =====================================
// 🎯 Ticket Logged Type APIs
// =====================================

// 🔹 Get all active ticket logged types
export const getAllTicketLoggedTypes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/TicketLoggedType/GetAll`);
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching ticket logged types:", error);
    throw error;
  }
};

// 🔹 Get ticket logged type by code
export const getTicketLoggedTypeByCode = async (code) => {
  try {
    if (!code) {
      throw new Error("Logged type code is required");
    }

    const response = await axios.get(
      `${Base_URL}/TicketLoggedType/GetByCode/${code}`,
    );

    return response.data;
  } catch (error) {
    console.error(
      `❌ Error fetching ticket logged type for code ${code}:`,
      error,
    );
    throw error;
  }
};

// =====================================
// 🎯 Ticket Log APIs
// =====================================

// 🔹 Get ticket logs by TicketId
export const getTicketLogsByTicketId = async (ticketId) => {
  try {
    if (!ticketId) {
      throw new Error("TicketId is required");
    }

    const response = await axios.get(
      `${Base_URL}/TicketLog/GetByTicketId/${ticketId}`,
    );

    // Backend returns 404 when no logs → UI-safe
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    // 🚫 No logs is NOT an error
    if (error?.response?.status === 404) {
      return [];
    }

    console.error(
      `❌ Error fetching ticket logs for TicketId ${ticketId}:`,
      error,
    );
    throw error;
  }
};

// =====================================
// 🎯 Ticket → Tasks + Logs APIs
// =====================================

// 🔹 Get tasks (TaskMaster) with logs (TaskLogOrg) by TicketId
export const getTasksByTicketId = async (ticketId) => {
  try {
    if (!ticketId) {
      throw new Error("TicketId is required");
    }

    const response = await axios.get(
      `${Base_URL}/TaskMaster/GetTasksByTicket/${ticketId}`,
    );

    // ✅ If backend sends array
    if (Array.isArray(response.data)) {
      return response.data;
    }

    // ✅ If backend sends message
    if (response.data?.message) {
      return [];
    }

    return [];
  } catch (error) {
    // backend may return 404
    if (error?.response?.status === 404) {
      return [];
    }

    console.error(
      `❌ Error fetching tasks & logs for TicketId ${ticketId}:`,
      error,
    );

    return [];
  }
};
// NEW: Get Building Block by Ticket
export const getBuildingBlockByTicket = async (ticketId) => {
  try {
    const res = await axios.get(
      `${Base_URL}/BuildingBlockMaster/GetBuildingBlockByTicket/${ticketId}`,
    );

    return res.data;
  } catch (error) {
    if (error.response?.status === 404) {
      return null; // ✅ handle gracefully
    }

    throw error;
  }
};

// =====================================
// 🎯 Ticket Work Log API
// =====================================

export const addTicketWorkLog = async (payload) => {
  return axios.post(`${Base_URL}/TicketLog/AddLog`, {
    ...payload,
    actionType: "WORK_LOG",
  });
};

// 🔹 Fetch tickets by FromMail
export const getTicketsByFromMail = async (email) => {
  const response = await axios.get(
    `${Base_URL}/TicketBasedOrganization/GetByFromMail`,
    { params: { email } },
  );
  return response.data;
};

// =====================================
// 🎯 Ticket Conversation APIs
// =====================================

export const getTicketThread = async (ticketId) => {
  const response = await axios.get(`${Base_URL}/tickets/${ticketId}/thread`);
  return response.data;
};

export const addTicketReply = async (ticketId, formData) => {
  const response = await axios.post(
    `${Base_URL}/tickets/${ticketId}/reply`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

export const addInternalNote = async (ticketId, note, createdBy) => {
  const response = await axios.post(
    `${Base_URL}/tickets/${ticketId}/internal-note`,
    note,
    {
      params: { createdBy },
    },
  );
  return response.data;
};

// =====================================
// 🎯 Ticket Remarks APIs
// =====================================

// 🔹 Add remark to ticket
export const addTicketRemark = async (payload) => {
  try {
    const response = await axios.post(
      `${Base_URL}/TicketBasedOrganization/AddRemark`,
      payload,
    );

    return response.data;
  } catch (error) {
    console.error("❌ Error adding ticket remark:", error);
    throw error;
  }
};

// 🔹 Get remarks by TicketId
export const getTicketRemarks = async (ticketId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TicketBasedOrganization/GetRemarks/${ticketId}`,
    );

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    if (error?.response?.status === 404) {
      return [];
    }

    console.error("❌ Error fetching ticket remarks:", error);
    throw error;
  }
};

export const getTicketSla = async (ticketId) => {
  const res = await axios.get(
    `${Base_URL}/TicketBasedOrganization/GetTicketSla/${ticketId}`,
  );
  return res.data;
};

export const getTicketSlaLogs = async (ticketId) => {
  const res = await axios.get(
    `${Base_URL}/TicketBasedOrganization/GetTicketSlaLogs/${ticketId}`,
  );
  return res.data;
};

export const resolveNamesApi = async (ids) => {
  try {
    const response = await axios.post(`${Base_URL}/Resource/ResolveNames`, ids);
    return response.data;
  } catch (error) {
    console.error("❌ Error resolving names:", error);
    return [];
  }
};

// ✅ NEW: Get full dropdown hierarchy
export const getTicketDropdownData = async () => {
  try {
    const response = await axios.get(`${Base_URL}/TicketDropdown/full`);
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching dropdown data:", error);
    throw error;
  }
};
